import { type ReactNode } from 'react'

import { Drawer, Icon, Layout, LogoLoader, Text } from '@loadsmart/miranda-react'

export function DrawerShell({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
}) {
  return (
    <Drawer open={isOpen} onClose={onClose}>
      <Drawer.Header>
        <Layout.Group align="center" gap="spacing-1">
          <Icon name="calendar" size="24px" />
          Schedule
        </Layout.Group>
        <Drawer.Close />
      </Drawer.Header>
      {children}
    </Drawer>
  )
}

export function DrawerLoadingBody({ label }: { label?: string }) {
  return (
    <Drawer.Body>
      <Layout.Stack align="center" gap="spacing-4" paddingT="spacing-16">
        <LogoLoader />
        {label != null && <Text color="color-text-secondary">{label}</Text>}
      </Layout.Stack>
    </Drawer.Body>
  )
}
